<template>
  <ValidationProvider tag="tr" mode="eager" :rules="veeRules" v-slot="{ invalid, errors }">
    <th scope="row" width="25%">利用教材</th>
    <td width="10%">
      <span class="bg-red">必須</span>
    </td>
    <td v-if="options !== null" class="form-inline no-margin-top">
      <div class="line-break">
        <span class="form-check-inline" v-for="product in options" :key="product.id">
          <input type="checkbox" class="checkbox-size" v-model="inputValue" :value="product" :id="product.name" />
          <label :for="product.name">{{ product.name }}</label>
        </span>
      </div>
      <slot name="afterInput" :invalid="invalid" :errors="errors" />
      <slot name="feedback" :invalid="invalid" :errors="errors">
        <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
      </slot>
      <p class="text-danger" v-if="errorText">{{ errorText }}</p>
    </td>
    <td v-else class="form-inline no-margin-top">
      <span class="text-danger">法人を選択後に表示されます</span>
    </td>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  data() {
    return {};
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [], // Ex: [{value: 1, text: 'abc'}, {value: 2, text: 'bcd'}]
    },
    errorText: {
      type: String,
      default: '',
    },
  },
  components: {
    ValidationProvider,
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    veeRules() {
      return { required: { allowFalse: false } };
    },
  },
};
</script>

<style scoped>
.line-break {
  width: 100%;
}
.checkbox-size {
  transform: scale(1.4);
  margin-right: 0.35rem;
}
</style>
